import flatMap from 'lodash/flatMap';
import isEmpty from 'lodash/isEmpty';
import uniqWith from 'lodash/uniqWith';

import { ROW_TYPE_CATEGORY, ROW_TYPE_FORM } from 'containers/ModulesPage/ModuleTableRowType';
import { createIdToObjectHashMap, recursiveSortItemsByName } from 'utils/array.utils';

export const arboBuilder = _ => {
  const arbo = [];

  return (categories, form) => {
    let currentLevel = arbo;

    if (!isEmpty(categories)) {
      categories.forEach((category, index) => {
        let childNode = currentLevel?.find(child => child.id === category.id);

        if (!childNode) {
          childNode = {
            ...category,
            content_type: ROW_TYPE_CATEGORY,
            children: [],
          };
          currentLevel.push(childNode);
        }

        currentLevel = childNode.children;

        if (index === categories.length - 1) {
          childNode.children.push({ ...form, parentId: childNode.id });
        }
      });
    } else {
      currentLevel.push(form);
    }

    return arbo;
  };
};

export const getCategoryTree = (pathInfosResult, categoriesAndFormsPaths) => {
  // retrieve categories and put them in a map for easy access
  const categoriesInfo = flatMap(pathInfosResult, pathInfo => pathInfo.categories_infos).map(
    catInfo => ({
      id: catInfo.category_id,
      isDeleted: catInfo.is_deleted,
      name: catInfo.name,
    }),
  );
  const categoryIdToCategoryInfo = createIdToObjectHashMap(categoriesInfo);

  // retrieve forms and put them in a map for easy access
  const formInfos = flatMap(pathInfosResult, pathInfo => pathInfo.forms_infos).map(formInfo => {
    const catFormId = formInfo.category_id
      ? `${formInfo.category_id}_${formInfo.form_id}`
      : `${formInfo.form_id}`;
    return {
      id: catFormId,
      isDeleted: formInfo.is_deleted,
    };
  });
  const catFormIdToFormInfo = createIdToObjectHashMap(formInfos);

  // create the tree
  const arboGenerator = arboBuilder();

  const cafps = flatMap(categoriesAndFormsPaths, cafp => cafp.categories_and_forms_paths);

  const categoryTree = uniqWith(
    cafps,
    (a, b) => a.form_id === b.form_id && a.category_path === b.category_path,
  ).reduce((_, cafp) => {
    const categoryFolderHierarchy =
      cafp.category_path !== ''
        ? cafp.category_path.split('/').map(categoryId => categoryIdToCategoryInfo.get(categoryId))
        : [];

    const catFormId = !isEmpty(categoryFolderHierarchy)
      ? `${categoryFolderHierarchy[categoryFolderHierarchy.length - 1].id}_${cafp.form_id}`
      : `${cafp.form_id}`;

    // object to add in the tree
    const formInfo = {
      ...catFormIdToFormInfo.get(catFormId),
      content_type: ROW_TYPE_FORM,
      name: cafp.form_name,
      id: cafp.form_id,
      unlinked: !catFormIdToFormInfo.has(catFormId),
    };

    // add object in the given folder hierarchy
    return arboGenerator(categoryFolderHierarchy, formInfo);
  }, null);

  return !categoryTree?.length ? [] : recursiveSortItemsByName(categoryTree);
};
